import {
  AfterContentInit,
  Component,
  ElementRef,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
  inject,
  WritableSignal,
  signal,
} from '@angular/core';
import { ServiceModel } from '@app/src/app/modules/service/classes/default/model/service.model';
import { buildPayload, Translation } from '@ckmk/angular';
import { ServiceCard } from '@app/src/app/modules/service/components/service-card/service-card';
import { ServiceService } from '@app/src/app/modules/service/service/service.service';

@Component({
  selector: 'services-home-container',
  standalone: true,
  imports: [ServiceCard, Translation],
  templateUrl: './services-home-container.html',
  styleUrl: './services-home-container.scss',
  host: {
    '[class.hidden]': 'itemsEmpty()',
  },
  encapsulation: ViewEncapsulation.None,
})
export class ServicesHomeContainer
  implements OnInit, OnChanges, OnDestroy, AfterContentInit
{
  protected readonly self = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly service = inject(ServiceService);

  protected readonly services: WritableSignal<ServiceModel[]> = signal<
    ServiceModel[]
  >([]);

  protected readonly itemsEmpty: WritableSignal<boolean> =
    signal<boolean>(true);

  public constructor() {}

  public ngOnInit() {
    this.service.services.onQuery((result, loading) => {
      if (!loading && result) {
        this.services.set(result);

        this.itemsEmpty.set(result.length === 0);
      }
    });

    this.fetchServices();
  }

  public ngOnChanges(changes: SimpleChanges) {}

  public ngOnDestroy() {
    this.service.services.unsubscribe(true);
  }

  public ngAfterContentInit() {}

  protected fetchServices(): void {
    this.service.services.watchQuery(
      buildPayload()
        .into('payload', (builder) =>
          builder
            .paginate(1, 3)
            .sort({
              createdAt: 'DESC',
            })
            .filters((filter) => filter.equalTo('active', true))
            .setMultiple({
              includeCategory: true,
              includePicture: true,
            }),
        )
        .build(),
    );
  }
}
